import React, { useState } from 'react';

function Branches({ showToast }) {
  const [branches, setBranches] = useState([
    { id: 1, code: 'CN-HN', name: 'Chi nhánh Hà Nội', address: '54 Liễu Giai, Ba Đình, Hà Nội', phone: '024.3845.6789', manager: 'Nguyễn Văn A', status: 'active' },
    { id: 2, code: 'CN-HCM', name: 'Chi nhánh Hồ Chí Minh', address: '235 Nguyễn Văn Cừ, Quận 5, TP.HCM', phone: '028.3835.6789', manager: 'Trần Thị B', status: 'active' },
    { id: 3, code: 'CN-DN', name: 'Chi nhánh Đà Nẵng', address: '123 Hùng Vương, Hải Châu, Đà Nẵng', phone: '0236.3845.678', manager: 'Lê Văn C', status: 'active' },
    { id: 4, code: 'CN-HP', name: 'Chi nhánh Hải Phòng', address: '67 Lạch Tray, Ngô Quyền, Hải Phòng', phone: '0225.3845.678', manager: 'Phạm Thị D', status: 'active' },
    { id: 5, code: 'CN-CT', name: 'Chi nhánh Cần Thơ', address: '89 Mậu Thân, Ninh Kiều, Cần Thơ', phone: '0292.3845.678', manager: 'Hoàng Văn E', status: 'active' },
    { id: 6, code: 'CN-NA', name: 'Chi nhánh Nghệ An', address: '45 Quang Trung, Vinh, Nghệ An', phone: '0238.3845.678', manager: 'Vũ Thị F', status: 'active' },
    { id: 7, code: 'CN-BD', name: 'Chi nhánh Bình Dương', address: '234 Đại lộ Bình Dương, Thủ Dầu Một', phone: '0274.3845.678', manager: 'Đặng Văn G', status: 'active' },
    { id: 8, code: 'CN-QN', name: 'Chi nhánh Quảng Ninh', address: '12 Hạ Long, Bãi Cháy, Quảng Ninh', phone: '0203.3845.678', manager: 'Bùi Thị H', status: 'active' },
  ]);

  const [searchText, setSearchText] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [showModal, setShowModal] = useState(false);
  const [editingBranch, setEditingBranch] = useState(null);
  const [viewMode, setViewMode] = useState('grid'); // 'grid', 'list', 'table'
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    address: '',
    phone: '',
    manager: '',
    status: 'active'
  });

  const filteredBranches = branches.filter(branch => {
    const matchSearch = branch.name.toLowerCase().includes(searchText.toLowerCase()) ||
                       branch.code.toLowerCase().includes(searchText.toLowerCase()) ||
                       branch.address.toLowerCase().includes(searchText.toLowerCase());
    const matchStatus = statusFilter === 'all' || branch.status === statusFilter;
    return matchSearch && matchStatus;
  });

  const openCreateModal = () => {
    setEditingBranch(null);
    setFormData({
      code: '',
      name: '',
      address: '',
      phone: '',
      manager: '',
      status: 'active'
    });
    setShowModal(true);
  };

  const openEditModal = (branch) => {
    setEditingBranch(branch);
    setFormData({
      code: branch.code,
      name: branch.name,
      address: branch.address,
      phone: branch.phone,
      manager: branch.manager,
      status: branch.status
    });
    setShowModal(true);
  };

  const handleSave = () => {
    if (!formData.code || !formData.name || !formData.address) {
      showToast('Vui lòng điền đầy đủ thông tin bắt buộc!', 'warning');
      return;
    }

    if (editingBranch) {
      setBranches(branches.map(b => 
        b.id === editingBranch.id 
          ? { ...b, ...formData }
          : b
      ));
      showToast('Cập nhật chi nhánh thành công!', 'success');
    } else {
      const newBranch = {
        id: Math.max(...branches.map(b => b.id), 0) + 1,
        ...formData
      };
      setBranches([...branches, newBranch]);
      showToast('Thêm chi nhánh mới thành công!', 'success');
    }
    setShowModal(false);
  };

  const deleteBranch = (id) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa chi nhánh này?')) {
      setBranches(branches.filter(b => b.id !== id));
      showToast('Xóa chi nhánh thành công!', 'success');
    }
  };

  const toggleStatus = (id) => {
    setBranches(branches.map(b => 
      b.id === id 
        ? { ...b, status: b.status === 'active' ? 'inactive' : 'active' }
        : b
    ));
    showToast('Cập nhật trạng thái thành công!', 'success');
  };

  return (
    <div className="container-fluid p-4">
      <div className="page-header-sticky">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="mb-1">
              <i className="bi bi-building me-2"></i>
              Quản lý Chi nhánh
            </h2>
            <p className="text-muted mb-0">Quản lý thông tin các chi nhánh ngân hàng</p>
          </div>
          <button className="btn btn-primary" onClick={openCreateModal}>
            <i className="bi bi-plus-circle me-2"></i>
            Thêm chi nhánh
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-6">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Tìm kiếm theo tên, mã, địa chỉ..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <select 
                className="form-select"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="all">Tất cả trạng thái</option>
                <option value="active">Đang hoạt động</option>
                <option value="inactive">Tạm ngưng</option>
              </select>
            </div>
            <div className="col-md-2">
              <div className="btn-group w-100" role="group">
                <button
                  className={`btn ${viewMode === 'grid' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('grid')}
                  title="Xem dạng lưới"
                >
                  <i className="bi bi-grid-3x3-gap"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('list')}
                  title="Xem dạng danh sách"
                >
                  <i className="bi bi-list-ul"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'table' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('table')}
                  title="Xem dạng bảng"
                >
                  <i className="bi bi-table"></i>
                </button>
              </div>
            </div>
            <div className="col-md-1">
              <div className="text-end">
                <span className="badge bg-info fs-6">
                  {filteredBranches.length}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Branches Display */}
      {/* Grid View */}
      {viewMode === 'grid' && (
        <div className="row g-4">
          {filteredBranches.map(branch => (
            <div key={branch.id} className="col-lg-4 col-md-6">
              <div className="card border-0 shadow-sm h-100 hover-lift" style={{borderLeft: `4px solid ${branch.status === 'active' ? '#28a745' : '#6c757d'}`}}>
                <div className="card-body">
                  <div className="d-flex justify-content-between mb-3">
                    <span className="badge bg-secondary">{branch.code}</span>
                    <span className={`badge ${branch.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>
                      {branch.status === 'active' ? 'Hoạt động' : 'Tạm ngưng'}
                    </span>
                  </div>
                  <h5 className="card-title">{branch.name}</h5>
                  <div className="mb-3">
                    <small><i className="bi bi-geo-alt me-1"></i>{branch.address}</small><br/>
                    <small><i className="bi bi-telephone me-1"></i>{branch.phone}</small><br/>
                    <small><i className="bi bi-person me-1"></i>{branch.manager}</small>
                  </div>
                  <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-outline-primary flex-fill" onClick={() => openEditModal(branch)} title="Chỉnh sửa">
                      <i className="bi bi-pencil"></i>
                    </button>
                    <button className={`btn btn-sm btn-outline-${branch.status === 'active' ? 'warning' : 'success'} flex-fill`} onClick={() => toggleStatus(branch.id)} title={branch.status === 'active' ? 'Tạm dừng' : 'Kích hoạt'}>
                      <i className="bi bi-toggle-on"></i>
                    </button>
                    <button className="btn btn-sm btn-outline-danger flex-fill" onClick={() => deleteBranch(branch.id)} title="Xóa">
                      <i className="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* List View */}
      {viewMode === 'list' && (
        <div className="row g-3">
          {filteredBranches.map(branch => (
            <div key={branch.id} className="col-12">
              <div className="card border-0 shadow-sm hover-lift" style={{borderLeft: `4px solid ${branch.status === 'active' ? '#28a745' : '#6c757d'}`}}>
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-md-7">
                      <div className="d-flex align-items-start gap-3">
                        <div className="badge bg-secondary align-self-start">{branch.code}</div>
                        <div className="flex-grow-1">
                          <h5 className="mb-1">{branch.name}</h5>
                          <div className="d-flex gap-3 flex-wrap">
                            <small><i className="bi bi-geo-alt me-1"></i>{branch.address}</small>
                            <small><i className="bi bi-telephone me-1"></i>{branch.phone}</small>
                            <small><i className="bi bi-person me-1"></i>GĐ: {branch.manager}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="d-flex gap-2 justify-content-end align-items-center">
                        <span className={`badge ${branch.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>
                          {branch.status === 'active' ? 'Hoạt động' : 'Tạm ngưng'}
                        </span>
                        <button className="btn btn-sm btn-outline-primary" onClick={() => openEditModal(branch)} title="Chỉnh sửa">
                          <i className="bi bi-pencil"></i>
                        </button>
                        <button className={`btn btn-sm btn-outline-${branch.status === 'active' ? 'warning' : 'success'}`} onClick={() => toggleStatus(branch.id)} title={branch.status === 'active' ? 'Tạm dừng' : 'Kích hoạt'}>
                          <i className="bi bi-toggle-on"></i>
                        </button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => deleteBranch(branch.id)} title="Xóa">
                          <i className="bi bi-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Table View */}
      {viewMode === 'table' && (
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Mã CN</th>
                    <th>Tên chi nhánh</th>
                    <th>Địa chỉ</th>
                    <th>Số điện thoại</th>
                    <th>Giám đốc</th>
                    <th>Trạng thái</th>
                    <th>Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredBranches.map(branch => (
                    <tr key={branch.id}>
                      <td><strong>{branch.code}</strong></td>
                      <td>{branch.name}</td>
                      <td>{branch.address}</td>
                      <td>{branch.phone}</td>
                      <td>{branch.manager}</td>
                      <td>
                        <span className={`badge ${branch.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>
                          {branch.status === 'active' ? 'Hoạt động' : 'Tạm ngưng'}
                        </span>
                      </td>
                      <td>
                        <button 
                          className="btn btn-sm btn-outline-primary me-2"
                          onClick={() => openEditModal(branch)}
                        >
                          <i className="bi bi-pencil"></i>
                        </button>
                        <button 
                          className="btn btn-sm btn-outline-warning me-2"
                          onClick={() => toggleStatus(branch.id)}
                        >
                          <i className="bi bi-toggle-on"></i>
                        </button>
                        <button 
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => deleteBranch(branch.id)}
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingBranch ? 'Cập nhật chi nhánh' : 'Thêm chi nhánh mới'}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Mã chi nhánh <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.code}
                      onChange={(e) => setFormData({...formData, code: e.target.value})}
                      placeholder="VD: CN-HN"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Tên chi nhánh <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      placeholder="VD: Chi nhánh Hà Nội"
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Địa chỉ <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.address}
                      onChange={(e) => setFormData({...formData, address: e.target.value})}
                      placeholder="Nhập địa chỉ đầy đủ"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Số điện thoại</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      placeholder="VD: 024.3845.6789"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Giám đốc</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.manager}
                      onChange={(e) => setFormData({...formData, manager: e.target.value})}
                      placeholder="Họ tên giám đốc"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Trạng thái</label>
                    <select 
                      className="form-select"
                      value={formData.status}
                      onChange={(e) => setFormData({...formData, status: e.target.value})}
                    >
                      <option value="active">Hoạt động</option>
                      <option value="inactive">Tạm ngưng</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Hủy
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  <i className="bi bi-save me-2"></i>
                  Lưu
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Branches;
